/**
 * #web_view.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Value } from "../../../../google/protobuf/struct.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { ConsentStatusEvent } from "../../effect_types/v1alpha/app_permission.js";
import { OrderResultEvent } from "../../effect_types/v1alpha/create_order.js";
import { FormCanceledEvent, FormSubmittedEvent } from "../../effect_types/v1alpha/show_form.js";
import { UpdateRequestContextEvent } from "../../effect_types/v1alpha/update_request_context.js";
import { RealtimeSubscriptionEvent } from "../../effects/v1alpha/realtime_subscriptions.js";
import { webViewImmersiveModeFromJSON, webViewImmersiveModeToJSON, } from "../../effects/web_view/v1alpha/immersive_mode.js";
import { WebViewScreenshotRequestEvent } from "../../effects/web_view/v1alpha/screenshot.js";
/**
 * Blocks only.
 *
 * @deprecated
 */
export var WebViewVisibility;
(function (WebViewVisibility) {
    WebViewVisibility[WebViewVisibility["WEBVIEW_VISIBLE"] = 0] = "WEBVIEW_VISIBLE";
    WebViewVisibility[WebViewVisibility["WEBVIEW_HIDDEN"] = 1] = "WEBVIEW_HIDDEN";
    WebViewVisibility[WebViewVisibility["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebViewVisibility || (WebViewVisibility = {}));
export function webViewVisibilityFromJSON(object) {
    switch (object) {
        case 0:
        case "WEBVIEW_VISIBLE":
            return WebViewVisibility.WEBVIEW_VISIBLE;
        case 1:
        case "WEBVIEW_HIDDEN":
            return WebViewVisibility.WEBVIEW_HIDDEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return WebViewVisibility.UNRECOGNIZED;
    }
}
export function webViewVisibilityToJSON(object) {
    switch (object) {
        case WebViewVisibility.WEBVIEW_VISIBLE:
            return 0;
        case WebViewVisibility.WEBVIEW_HIDDEN:
            return 1;
        case WebViewVisibility.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseWebViewPostMessageEvent() {
    return { message: undefined, jsonString: "" };
}
export const WebViewPostMessageEvent = {
    $type: "devvit.ui.events.v1alpha.WebViewPostMessageEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.message !== undefined) {
            Value.encode(Value.wrap(message.message), writer.uint32(10).fork()).ldelim();
        }
        if (message.jsonString !== "") {
            writer.uint32(18).string(message.jsonString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewPostMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = Value.unwrap(Value.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.jsonString = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object?.message) ? object.message : undefined,
            jsonString: isSet(object.jsonString) ? globalThis.String(object.jsonString) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined) {
            obj.message = message.message;
        }
        if (message.jsonString !== "") {
            obj.jsonString = message.jsonString;
        }
        return obj;
    },
    create(base) {
        return WebViewPostMessageEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewPostMessageEvent();
        message.message = object.message ?? undefined;
        message.jsonString = object.jsonString ?? "";
        return message;
    },
};
messageTypeRegistry.set(WebViewPostMessageEvent.$type, WebViewPostMessageEvent);
function createBaseWebViewFullScreenEvent() {
    return { visibility: 0 };
}
export const WebViewFullScreenEvent = {
    $type: "devvit.ui.events.v1alpha.WebViewFullScreenEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.visibility !== 0) {
            writer.uint32(8).int32(message.visibility);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewFullScreenEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.visibility = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { visibility: isSet(object.visibility) ? webViewVisibilityFromJSON(object.visibility) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.visibility !== 0) {
            obj.visibility = webViewVisibilityToJSON(message.visibility);
        }
        return obj;
    },
    create(base) {
        return WebViewFullScreenEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewFullScreenEvent();
        message.visibility = object.visibility ?? 0;
        return message;
    },
};
messageTypeRegistry.set(WebViewFullScreenEvent.$type, WebViewFullScreenEvent);
function createBaseWebViewEvent() {
    return { postMessage: undefined, fullScreen: undefined };
}
export const WebViewEvent = {
    $type: "devvit.ui.events.v1alpha.WebViewEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.postMessage !== undefined) {
            WebViewPostMessageEvent.encode(message.postMessage, writer.uint32(10).fork()).ldelim();
        }
        if (message.fullScreen !== undefined) {
            WebViewFullScreenEvent.encode(message.fullScreen, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.postMessage = WebViewPostMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fullScreen = WebViewFullScreenEvent.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            postMessage: isSet(object.postMessage) ? WebViewPostMessageEvent.fromJSON(object.postMessage) : undefined,
            fullScreen: isSet(object.fullScreen) ? WebViewFullScreenEvent.fromJSON(object.fullScreen) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.postMessage !== undefined) {
            obj.postMessage = WebViewPostMessageEvent.toJSON(message.postMessage);
        }
        if (message.fullScreen !== undefined) {
            obj.fullScreen = WebViewFullScreenEvent.toJSON(message.fullScreen);
        }
        return obj;
    },
    create(base) {
        return WebViewEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewEvent();
        message.postMessage = (object.postMessage !== undefined && object.postMessage !== null)
            ? WebViewPostMessageEvent.fromPartial(object.postMessage)
            : undefined;
        message.fullScreen = (object.fullScreen !== undefined && object.fullScreen !== null)
            ? WebViewFullScreenEvent.fromPartial(object.fullScreen)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewEvent.$type, WebViewEvent);
function createBaseWebViewImmersiveModeChangedEvent() {
    return { immersiveMode: 0 };
}
export const WebViewImmersiveModeChangedEvent = {
    $type: "devvit.ui.events.v1alpha.WebViewImmersiveModeChangedEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.immersiveMode !== 0) {
            writer.uint32(8).int32(message.immersiveMode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewImmersiveModeChangedEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.immersiveMode = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { immersiveMode: isSet(object.immersiveMode) ? webViewImmersiveModeFromJSON(object.immersiveMode) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.immersiveMode !== 0) {
            obj.immersiveMode = webViewImmersiveModeToJSON(message.immersiveMode);
        }
        return obj;
    },
    create(base) {
        return WebViewImmersiveModeChangedEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewImmersiveModeChangedEvent();
        message.immersiveMode = object.immersiveMode ?? 0;
        return message;
    },
};
messageTypeRegistry.set(WebViewImmersiveModeChangedEvent.$type, WebViewImmersiveModeChangedEvent);
function createBaseWebViewInternalEventMessage() {
    return {
        id: "",
        formCanceled: undefined,
        formSubmitted: undefined,
        realtimeEvent: undefined,
        immersiveModeEvent: undefined,
        consentStatus: undefined,
        orderResult: undefined,
        updateRequestContext: undefined,
        screenshotRequest: undefined,
    };
}
export const WebViewInternalEventMessage = {
    $type: "devvit.ui.events.v1alpha.WebViewInternalEventMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.formCanceled !== undefined) {
            FormCanceledEvent.encode(message.formCanceled, writer.uint32(18).fork()).ldelim();
        }
        if (message.formSubmitted !== undefined) {
            FormSubmittedEvent.encode(message.formSubmitted, writer.uint32(26).fork()).ldelim();
        }
        if (message.realtimeEvent !== undefined) {
            RealtimeSubscriptionEvent.encode(message.realtimeEvent, writer.uint32(34).fork()).ldelim();
        }
        if (message.immersiveModeEvent !== undefined) {
            WebViewImmersiveModeChangedEvent.encode(message.immersiveModeEvent, writer.uint32(42).fork()).ldelim();
        }
        if (message.consentStatus !== undefined) {
            ConsentStatusEvent.encode(message.consentStatus, writer.uint32(58).fork()).ldelim();
        }
        if (message.orderResult !== undefined) {
            OrderResultEvent.encode(message.orderResult, writer.uint32(66).fork()).ldelim();
        }
        if (message.updateRequestContext !== undefined) {
            UpdateRequestContextEvent.encode(message.updateRequestContext, writer.uint32(74).fork()).ldelim();
        }
        if (message.screenshotRequest !== undefined) {
            WebViewScreenshotRequestEvent.encode(message.screenshotRequest, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewInternalEventMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.formCanceled = FormCanceledEvent.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.formSubmitted = FormSubmittedEvent.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.realtimeEvent = RealtimeSubscriptionEvent.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.immersiveModeEvent = WebViewImmersiveModeChangedEvent.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.consentStatus = ConsentStatusEvent.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.orderResult = OrderResultEvent.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.updateRequestContext = UpdateRequestContextEvent.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.screenshotRequest = WebViewScreenshotRequestEvent.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            formCanceled: isSet(object.formCanceled) ? FormCanceledEvent.fromJSON(object.formCanceled) : undefined,
            formSubmitted: isSet(object.formSubmitted) ? FormSubmittedEvent.fromJSON(object.formSubmitted) : undefined,
            realtimeEvent: isSet(object.realtimeEvent) ? RealtimeSubscriptionEvent.fromJSON(object.realtimeEvent) : undefined,
            immersiveModeEvent: isSet(object.immersiveModeEvent)
                ? WebViewImmersiveModeChangedEvent.fromJSON(object.immersiveModeEvent)
                : undefined,
            consentStatus: isSet(object.consentStatus) ? ConsentStatusEvent.fromJSON(object.consentStatus) : undefined,
            orderResult: isSet(object.orderResult) ? OrderResultEvent.fromJSON(object.orderResult) : undefined,
            updateRequestContext: isSet(object.updateRequestContext)
                ? UpdateRequestContextEvent.fromJSON(object.updateRequestContext)
                : undefined,
            screenshotRequest: isSet(object.screenshotRequest)
                ? WebViewScreenshotRequestEvent.fromJSON(object.screenshotRequest)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.formCanceled !== undefined) {
            obj.formCanceled = FormCanceledEvent.toJSON(message.formCanceled);
        }
        if (message.formSubmitted !== undefined) {
            obj.formSubmitted = FormSubmittedEvent.toJSON(message.formSubmitted);
        }
        if (message.realtimeEvent !== undefined) {
            obj.realtimeEvent = RealtimeSubscriptionEvent.toJSON(message.realtimeEvent);
        }
        if (message.immersiveModeEvent !== undefined) {
            obj.immersiveModeEvent = WebViewImmersiveModeChangedEvent.toJSON(message.immersiveModeEvent);
        }
        if (message.consentStatus !== undefined) {
            obj.consentStatus = ConsentStatusEvent.toJSON(message.consentStatus);
        }
        if (message.orderResult !== undefined) {
            obj.orderResult = OrderResultEvent.toJSON(message.orderResult);
        }
        if (message.updateRequestContext !== undefined) {
            obj.updateRequestContext = UpdateRequestContextEvent.toJSON(message.updateRequestContext);
        }
        if (message.screenshotRequest !== undefined) {
            obj.screenshotRequest = WebViewScreenshotRequestEvent.toJSON(message.screenshotRequest);
        }
        return obj;
    },
    create(base) {
        return WebViewInternalEventMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewInternalEventMessage();
        message.id = object.id ?? "";
        message.formCanceled = (object.formCanceled !== undefined && object.formCanceled !== null)
            ? FormCanceledEvent.fromPartial(object.formCanceled)
            : undefined;
        message.formSubmitted = (object.formSubmitted !== undefined && object.formSubmitted !== null)
            ? FormSubmittedEvent.fromPartial(object.formSubmitted)
            : undefined;
        message.realtimeEvent = (object.realtimeEvent !== undefined && object.realtimeEvent !== null)
            ? RealtimeSubscriptionEvent.fromPartial(object.realtimeEvent)
            : undefined;
        message.immersiveModeEvent = (object.immersiveModeEvent !== undefined && object.immersiveModeEvent !== null)
            ? WebViewImmersiveModeChangedEvent.fromPartial(object.immersiveModeEvent)
            : undefined;
        message.consentStatus = (object.consentStatus !== undefined && object.consentStatus !== null)
            ? ConsentStatusEvent.fromPartial(object.consentStatus)
            : undefined;
        message.orderResult = (object.orderResult !== undefined && object.orderResult !== null)
            ? OrderResultEvent.fromPartial(object.orderResult)
            : undefined;
        message.updateRequestContext = (object.updateRequestContext !== undefined && object.updateRequestContext !== null)
            ? UpdateRequestContextEvent.fromPartial(object.updateRequestContext)
            : undefined;
        message.screenshotRequest = (object.screenshotRequest !== undefined && object.screenshotRequest !== null)
            ? WebViewScreenshotRequestEvent.fromPartial(object.screenshotRequest)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewInternalEventMessage.$type, WebViewInternalEventMessage);
function createBaseWebViewMessageEvent() {
    return { data: undefined };
}
export const WebViewMessageEvent = {
    $type: "devvit.ui.events.v1alpha.WebViewMessageEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.data !== undefined) {
            WebViewMessageEvent_MessageData.encode(message.data, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.data = WebViewMessageEvent_MessageData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { data: isSet(object.data) ? WebViewMessageEvent_MessageData.fromJSON(object.data) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.data !== undefined) {
            obj.data = WebViewMessageEvent_MessageData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return WebViewMessageEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewMessageEvent();
        message.data = (object.data !== undefined && object.data !== null)
            ? WebViewMessageEvent_MessageData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewMessageEvent.$type, WebViewMessageEvent);
function createBaseWebViewMessageEvent_MessageData() {
    return { type: "", data: undefined };
}
export const WebViewMessageEvent_MessageData = {
    $type: "devvit.ui.events.v1alpha.WebViewMessageEvent.MessageData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.data !== undefined) {
            WebViewInternalEventMessage.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewMessageEvent_MessageData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = WebViewInternalEventMessage.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            data: isSet(object.data) ? WebViewInternalEventMessage.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.data !== undefined) {
            obj.data = WebViewInternalEventMessage.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return WebViewMessageEvent_MessageData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewMessageEvent_MessageData();
        message.type = object.type ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? WebViewInternalEventMessage.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WebViewMessageEvent_MessageData.$type, WebViewMessageEvent_MessageData);
function isSet(value) {
    return value !== null && value !== undefined;
}
